import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { ResumenIngresoDetalleContent } from './components/ResumenIngresoDetalleContent';

export default function ResumenIngresoDetalle() {
    return (
        <MainContent
            component={<ResumenIngresoDetalleContent />}
            titulo='Detalle del Resumen de ingreso'
            noBackground
        />
    );

};
